import { useMemo } from 'react'
import { Outlet } from 'react-router-dom'
import AppBar from '@mui/material/AppBar'
import Box from '@mui/material/Box'
import { styled, Theme, useTheme } from '@mui/material/styles'
import Toolbar from '@mui/material/Toolbar'

import { Header } from './Header'

const drawerWidth = 260
const Main = styled('main')(({ theme, open }: { theme: Theme; open: boolean }) => ({
  backgroundColor: theme.palette.background.paper,
  width: '100%',
  zIndex: 1,
  minHeight: 'calc(100vh - 80px)',
  flexGrow: 1,
  padding: '20px',
  marginTop: '75px',
  marginRight: '20px',
  borderRadius: `8px`,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  ...(!open && {
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    [theme.breakpoints.up('md')]: {
      width: `calc(100% - ${drawerWidth}px)`,
    },
    [theme.breakpoints.down('md')]: {
      width: `calc(100% - ${drawerWidth}px)`,
      padding: '16px',
    },
    [theme.breakpoints.down('sm')]: {
      width: `calc(100% - ${drawerWidth}px)`,
      padding: '16px',
      marginRight: '10px',
    },
  }),
  ...(open && {
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    marginLeft: 0,
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    width: `calc(100% - ${drawerWidth}px)`,
    [theme.breakpoints.down('md')]: {
      marginLeft: '20px',
    },
    [theme.breakpoints.down('sm')]: {
      marginLeft: '10px',
    },
  }),
}))

const Layout = () => {
  const theme = useTheme()

  const header = useMemo(
    () => (
      <Toolbar
        sx={{
          width: '100%',
          [theme.breakpoints.up('md')]: {
            padding: '10px 16px 0px 16px',
          },
        }}
      >
        <Header />
      </Toolbar>
    ),
    []
  )
  return (
    <Box sx={{ display: 'flex' }}>
      <AppBar
        color={'inherit'}
        elevation={0}
        enableColorOnDark
        position={'fixed'}
        sx={{
          width: '100%',
          height: '75px',
          bgcolor: theme.palette.background.default,
        }}
      >
        {header}
      </AppBar>

      <Main open={false} theme={theme}>
        <Box>
          <Outlet />
        </Box>
      </Main>
    </Box>
  )
}

export default Layout
